import { render } from "./levelComponent.vue?vue&type=template&id=3412314e&scoped=true"
import script from "./levelComponent.vue?vue&type=script&lang=js"
export * from "./levelComponent.vue?vue&type=script&lang=js"

import "./levelComponent.vue?vue&type=style&index=0&id=3412314e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3412314e"]])

export default __exports__